// extracted by mini-css-extract-plugin
export default {"controls":"vp_PFSHK"};